// src/components/Footer.js
import React, { useState } from 'react';
import {
  FaFacebookF,
  FaTwitter,
  FaInstagram,
  FaYoutube,
  FaEnvelope,
  FaPhone
} from 'react-icons/fa';
import './Footer.css';
import mebLogo from '../assets/meb1.png';

const sections = [
  {
    title: 'Kurumsal',
    links: ['Amacımız ve Yaklaşımımız', 'Vizyon & Misyon', 'İlkelerimiz']
  },
  {
    title: 'Okullarımız',
    links: ['Anaokulu', 'İlkokul', 'Ortaokul']
  },
  {
    title: 'Neden Yeldeğirmeni?',
    links: ['Demokratik Okul', 'Ekolojik Okul', 'Dil Programları', 'Atölyeler']
  },
  {
    title: `ZEZE’nin Bahçesi`,
    links: ['Etkinlik Takvimi', 'Fotoğraf Galerisi']
  },
  {
    title: 'VIP Kurs',
    links: [
      'VIP Kurs','İlkokul Etüt','5-6-7 Sınıflar','LGS Hazırlık',
      '9-10-11 Sınıflar','12 ve Mezun YKS','Özel Dersler',
      'Deneme Kulübü','Cafe Kütüphane'
    ]
  }
];

const contactSection = {
  title: 'Bize Ulaşın',
  links: ['Kariyer', 'İletişim']
};

export default function Footer() {
  const [openSection, setOpenSection] = useState(null);
  const toggle = title => setOpenSection(openSection === title ? null : title);

  return (
    <footer className="footer">
      <div className="footer-top">
        <div className="footer-logo">
          <span className="footer-slogan">Mutlu Çocuk Öğrenir !</span>
        </div>
        
         </div>
            

      <div className="footer-bottom">
        <div className="footer-copy">© Yeldeğirmeni Eğitim Kurumları</div>
        <div className="footer-info">
          <div className="info-item">
            <FaEnvelope className="footer-icon" />
            <a href="mailto:info@yeldegirmeniegitimkurumlari.com">
              info@yeldegirmeniegitimkurumlari.com
            </a>
          </div>
          <div className="info-item">
            <FaPhone className="footer-icon" />
            <a href="tel:05498303731">0(549) 830 37 31</a>
          </div>
        </div>
        <div className="footer-social">
        <a href="https://www.instagram.com/yeldegirmeniegitimkurumlari/" aria-label="Instagram"><FaInstagram /></a>
        <a href="https://www.facebook.com/yeldegirmeniegitim/?locale=tr_TR" aria-label="Facebook"><FaFacebookF /></a>      
        </div>
        <div className="footer-meb">
          <img src={mebLogo} alt="MEB Logosu" />
        </div>
      </div>
    </footer>
);
}
